export default __webpack_public_path__ + "46429cff1208fbd4565cbd36d569d3b0.svg";